/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

import StateMachineFactory from '../../state-machine/state-machine-factory';

/**
 * Životní cyklus ovladače pro zobrazování médií.
 * Pomocná třída pro kontrolu správné posloupnosti volání metod.
 *
 * ![Diagram stavového automatu](./core/viewer/life-cycle/viewer-life-cycle.doc.png)
 */
class ViewerLifeCycle {
  constructor() {
    /**
     * Stavový automat životního cyklu.
     * @private
     */
    this.stateMachine = new StateMachineFactory().create({
      init: 'created',
      transitions: [
        { name: 'enter', from: 'seized', to: 'entered' },
        { name: 'leave', from: ['seized', 'entered'], to: 'left' },
        { name: 'release', from: ['left', 'seized'], to: 'released' },
        { name: 'seize', from: 'created', to: 'seized' }
      ]
    });
  }

  /**
   * Zahájí zobrazení média a jeho přehrávání.
   * @template T
   * @param {() => T | PromiseLike<T>} cb Async operace, které se provádějí při zobrazení.
   * @returns {Promise<T>} Výsledek operací při zobrazení.
   */
  enter(cb) {
    return this.stateMachine.transitAsync('enter', cb);
  }

  /**
   * Zahájí skrytí média a ukončení jeho přehrávání.
   * @template T
   * @param {() => T | PromiseLike<T>} cb Async operace, které se provádějí při skrytí.
   * @returns {Promise<T>} Výsledek operací při skrytí.
   */
  leave(cb) {
    return this.stateMachine.transitAsync('leave', cb);
  }

  /**
   * Uvolní sdílený element k dalšímu použití.
   * @template T
   * @param {() => T | PromiseLike<T>} cb Async operace, které se provádějí při uvolnění.
   * @returns {Promise<T>} Výsledek operací při uvolnění.
   */
  release(cb) {
    return this.stateMachine.transitAsync('release', cb);
  }

  /**
   * Převezme kontrolu nad sdíleným elementem.
   * @template T
   * @param {() => T | PromiseLike<T>} cb Async operace, které se provádějí při přebírání.
   * @returns {Promise<T>} Výsledek operací při přebírání.
   */
  seize(cb) {
    return this.stateMachine.transitAsync('seize', cb);
  }
}

export default ViewerLifeCycle;
